module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxMDYxIiBoZWlnaHQ9IjEwNjEiPjxwYXRoIG9wYWNpdHk9Ii44IiBmaWxsPSIjMjAyMDIwIiBkPSJNLjUuNWgxMDYwdjEwNjBILjV6Ii8+PC9zdmc+"


//////////////////
// WEBPACK FOOTER
// ./src/assets/slider/benefits/ecp_vorteile_slide4_part2.svg
// module id = WuMK
// module chunks = 1